import {
  CustomButton,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomModal,
  CustomNumberInput,
  useText,
  Text,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback } from 'react';
import '@src/styles/companyInformation/creditcards/provisionModal.scss';
import { Form } from 'antd';
import { useDispatch } from 'react-redux';
import { updateProvisionDay } from '@src/store/slice/mobilExpressSlice';

const ProvisionDateModal = ({ modalVisible, handleModalVisible, activeCard, init }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const handleSave = useCallback(
    async (e) => {
      const values = await form.validateFields();
      const action = await dispatch(
        updateProvisionDay({
          VouId: activeCard.vouId,
          ProvisionDay: +values.provisionDate,
          CardToken: activeCard.cardToken,
          Type: 1,
        }),
      );
      if (updateProvisionDay.fulfilled.match(action)) {
        await init(activeCard.vouId);
        handleModalVisible(false);
      }
    },
    [activeCard],
  );
  const handleCloseProvisionModal = useCallback(
    (e) => {
      e.preventDefault();
      form.resetFields();
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  return (
    <CustomModal
      className="provision-date-modal"
      maskClosable={false}
      footer={false}
      title={useText('authorizationDate')}
      visible={modalVisible}
      onCancel={handleCloseProvisionModal}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="provision-date-container">
        <h5>
          <Text t="dateWhenPaymentWillBeTakenFromYour" />
        </h5>
        <p>
          <Text t="theOrdersYouPlaceAreActivatedAfterThe" />
        </p>

        <CustomForm
          name="provisionDateForm"
          className="provision-date-form"
          initialValues={{}}
          autoComplete="off"
          layout={'horizontal'}
          form={form}
        >
          <CustomFormItem
            label={false}
            name="provisionDate"
            className="daily-form-item"
            rules={[
              { required: true, message: 'Lütfen günü giriniz' },
              { type: 'string', max: 2 },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (value > 0 && value < 32) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(
                      new Error('Lütfen 1-31 arasında bir sayısal bir değer giriniz.'),
                    );
                  }
                },
              }),
            ]}
          >
            <div className="daily-form-item-content">
              <div className="daily-form-input-content">
                <span>
                  <Text t="ofEachMonth" />{' '}
                </span>
                <CustomNumberInput
                  id="companyInformation-creditCards-ProvisionDateModal-provisionDate-input"
                  autoComplete="off"
                  maxLength={2}
                  height={32}
                  defaultValue={activeCard?.provision_Day}
                  onChange={() => { }}
                  onInput={(value) => { }}
                />
                <span>
                  <Text t="day2" />
                </span>
              </div>
            </div>
          </CustomFormItem>
        </CustomForm>

        <div className="footer-btn">
          <CustomButton
            id="companyInformation-creditCards-provisionDateModal-save-btn"
            className="save-btn"
            onClick={handleSave}
          >
            <Text t="approve2" />
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default ProvisionDateModal;
